<div class="m-4 flex items-center justify-between">
  <div></div>
  <div class="typo-h5-semibold text-text-secondary">
    @if (scheduleAppointment()) {
      {{ 'schedule_details_title_appointment' | translate }}
    } @else {
      {{ 'schedule_details_title_my_collabs' | translate }}
    }
  </div>
  @if (scheduleAppointment()) {
    <button class="text-primary-blue" (click)="onCloseClick()">
      <svg-icon size="md" key="px-24-x"></svg-icon>
    </button>
  } @else {
    <button class="btn-icon-dark h-10 w-10 rounded-2xl" (click)="onCreateNewCollab()">
      <svg-icon size="md" key="px-24-edit"></svg-icon>
    </button>
  }
</div>

<div class="flex h-full flex-col overflow-scroll">
  @if (scheduleAppointment(); as vm) {
    <lib-schedule-details class="pb-4" [vm]="vm" (avatarClick)="onScheduleAvatarClick()" (editClick)="onScheduleEditClick()" />

    @if (!vm.appointmentDetails.isPreRegistrationAppointment) {
      <div class="typo-h3-semibold pb-2 pl-7 pr-4 uppercase tracking-wider">{{ 'schedule_details_collabs' | translate }}</div>
    }
  }

  @if (!scheduleAppointment()?.appointmentDetails?.isPreRegistrationAppointment) {
    <div class="mb-3 flex gap-1 ps-[28px]">
      <button
        type="button"
        class="flex items-center justify-center self-stretch overflow-hidden rounded-[8px] border px-2 py-1 text-primary-blue transition-colors"
        [ngClass]="{
          'border-primary-blue-pressed bg-primary-blue-pressed text-text-white': isDirectToMeActive(),
          'border-primary-blue bg-background-white': !isDirectToMeActive()
        }"
        (click)="onDirectToMeClick()"
      >
        <span class="typo-h7-semibold">{{ 'home_right_side_bar_direct_to_me_button' | translate }}</span>
      </button>
      <button
        type="button"
        class="flex items-center justify-center self-stretch overflow-hidden rounded-[8px] border px-2 py-1 text-primary-blue transition-colors"
        [ngClass]="{
          'border-primary-blue-pressed bg-primary-blue-pressed text-text-white': isUnreadActive(),
          'border-primary-blue bg-background-white': !isUnreadActive()
        }"
        (click)="onUnreadClick()"
      >
        <span class="typo-h7-semibold">{{ 'home_right_side_bar_unread_button' | translate }}</span>
      </button>
      @if (!scheduleAppointment()) {
        <button
          type="button"
          class="flex items-center justify-center self-stretch overflow-hidden rounded-[8px] border px-2 py-1 text-primary-blue transition-colors"
          [ngClass]="{
            'border-primary-blue-pressed bg-primary-blue-pressed text-text-white': isTeamCollabActive(),
            'border-primary-blue bg-background-white': !isTeamCollabActive()
          }"
          (click)="onTeamCollabClick()"
        >
          <span class="typo-h7-semibold">{{ 'collab_type_team_collab' | translate }}</span>
        </button>
        <button
          type="button"
          class="flex items-center justify-center self-stretch overflow-hidden rounded-[8px] border px-2 py-1 text-primary-blue transition-colors"
          [ngClass]="{
            'border-primary-blue-pressed bg-primary-blue-pressed text-text-white': isClinicalCollabActive(),
            'border-primary-blue bg-background-white': !isClinicalCollabActive()
          }"
          (click)="onClinicalCollabClick()"
        >
          <span class="typo-h7-semibold">{{ 'collab_type_clinical_collab' | translate }}</span>
        </button>
      }
    </div>
    @if (showMessageCount()) {
      <div class="typo-h7-light mb-3 w-full text-end text-text-light">
        {{ 'home_right_side_bar_message_count' | translate: { input1: collabs().length } }}
      </div>
    }

    <div class="flex w-full flex-grow flex-col">
      @for (collab of collabs(); track collab.id) {
        <a
          class="border-b border-b-background-disabled focus:outline-none"
          [class.border-b-0]="$last"
          [ffdDynamicRouterLink]="
            scheduleAppointment()?.patientId
              ? {
                  routerLink: 'collabOnSiteForPatient',
                  params: [selectedSiteId() || '', scheduleAppointment()?.patientId || '']
                }
              : {
                  routerLink: 'allCollaborationsOnSite',
                  params: [selectedSiteId() || '']
                }
          "
          [queryParams]="{ collaborationId: collab.id }"
          (focusin)="setFocusedCollab(collab.id)"
          (focusout)="removeFocusedCollab()"
        >
          <lib-collaboration-list-item
            [participants]="collab.avatars ?? []"
            [subject]="collab.title | collaborationDynamicTitle: collab.participants : currentUserIds()"
            [participantsString]="undefined | collaborationDynamicTitle: collab.participants : currentUserIds()"
            [hasUnreadMessage]="collab.hasUnreadMessage"
            [hasAttachmentInLastMessage]="collab.hasAttachmentInLastMessage"
            [dateOfLastMessage]="collab.dateOfLastMessage"
            [lastMessage]="collab.lastMessage"
            [lastMessageSenderFirstName]="collab.lastMessageSenderFirstName"
            [linkedPatient]="collab.linkedPatient"
            [isSelected]="collab.id === focusedCollabId()"
            [daysLeftOfDeletion]="collab.daysLeftOfDeletion"
            [isCreatedBySelf]="collab.isCreatedBySelf"
            [isSupportCollab]="collab.isSupportCollab"
            [isUserSiteAdmin]="collab.isUserSiteAdmin"
            (leaveCollaboration)="onLeaveCollaborationClick(collab.id)"
            (recoverCollaboration)="onRecoverCollaborationClick(collab.id)"
            (deleteCollaboration)="onDeleteCollaborationClick(collab.id, $event)"
          ></lib-collaboration-list-item>
        </a>
      }
      @if (showEmptyState()) {
        <div class="mb-6 mt-12 flex flex-1 flex-col items-center justify-center gap-3 self-center">
          <div class="flex h-[56px] w-[56px] items-center justify-center rounded-full bg-background-disabled/50 p-3">
            <svg-icon class="relative z-10 text-text-light" key="px-24-collab" size="md"></svg-icon>
          </div>

          <span class="typo-h5-light text-center font-light text-text-light">
            {{ (isFiltered() ? 'collab_sidebar_filter_no_colllabs' : 'collab_sidebar_no_collabs') | translate }}
          </span>
        </div>
      }
    </div>
    @if (showSeeAll()) {
      <div class="bottom-0 z-10 w-full bg-background-white py-2">
        <button
          class="btn-text mx-auto"
          [ffdDynamicRouterLink]="
            scheduleAppointment()?.patientId
              ? {
                  routerLink: 'collabOnSiteForPatient',
                  params: [selectedSiteId() || '', scheduleAppointment()?.patientId || '']
                }
              : {
                  routerLink: 'allCollaborationsOnSite',
                  params: [selectedSiteId() || '']
                }
          "
          [appQueryParams]="{ fromHome: true }"
        >
          {{ 'home_right_side_bar_see_all_button' | translate }}
        </button>
      </div>
    }
  }
</div>
